import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {AdminAuthenticationService} from "@app/security/admin-authentication.service";
import {NavigationUtilsService} from "@ui-kit/utils/service/navigation-utils.service";
import {AdminContextService} from "@app/security/admin-context.service";

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  constructor(
    private auth: AdminAuthenticationService,
    private context: AdminContextService,
    private utilService: NavigationUtilsService,
  ) {
  }

  public canActivateRoute(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.validLogin() && this.verified()) {
      return true;
    }

    if (!this.tryNavigateToVerify(route.url.toString(), route.paramMap)) {
      this.auth.logout(true);
    }
    return false;
  }

  /**
   * If the user is logged in but not verified, navigate to the verify page
   * @private
   * @return boolean - if the navigation was invoked
   */
  public tryNavigateToVerify(returnUri: string,
                             queryParams: any,
                             message: string | null = "Please verify your account to keep your profile secure."): boolean {
    if (this.validUnverifiedLogin()) {
      const uri = '/account/verify';
      this.utilService.navigateWithQueryParams(uri, message,
        {
          ...queryParams,
          sendOtp: true,
          returnUrl: returnUri
        })
        .catch((error: string) => {
          console.log(error);
        });
      return true;
    }
    return false;
  }

  public validLogin(): boolean {
    return !!(this.auth.getToken() && this.auth.getExpiration() > new Date() && this.context.currentUser !== null);
  }

  private verified(): boolean {
    return this.auth.isVerified;
  }

  private validUnverifiedLogin(): boolean {
    return this.validLogin() && !this.verified();
  }

}
